import {styled, Typography} from '@mui/material';

const StyledTypography = styled(Typography)`
	ul {
		list-style-type: disc;
		padding-left: 24px;
		margin: 8px 0;
	}

	ol {
		list-style-type: decimal;
		padding-left: 24px;
		margin: 8px 0;
	}

	li {
		margin-bottom: 4px;
	}
`;

export {StyledTypography};
